// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import './WorldClock.css'; // Re-use existing CSS or create new if needed

const AnalogClock = ({ time }) => {
  // Calculate rotation degrees
  const seconds = time.seconds();
  const minutes = time.minutes();
  const hours = time.hours();

  const secondDegrees = ((seconds / 60) * 360) + 90;
  const minuteDegrees = ((minutes / 60) * 360) + ((seconds/60)*6) + 90;
  const hourDegrees = ((hours / 12) * 360) + ((minutes/60)*30) + 90;

  return (
    <div className="analog-clock">
      <div className="clock-face">
        <div 
            className="hand hour-hand" 
            style={{ transform: `rotate(${hourDegrees}deg)` }} 
        />
        <div 
            className="hand minute-hand" 
            style={{ transform: `rotate(${minuteDegrees}deg)` }} 
        />
        <div 
            className="hand second-hand" 
            style={{ transform: `rotate(${secondDegrees}deg)` }} 
        />
        <div className="center-dot"></div>
        
        {/* Optional: Hour Markers */}
        {[...Array(12)].map((_, i) => (
             <div 
                key={i} 
                className="hour-marker" 
                style={{ transform: `rotate(${i * 30}deg)` }}
             ></div>
        ))}

      </div>
    </div>
  );
};

export default AnalogClock;
